import { render } from "./Paso3InstruccionesComponent.vue?vue&type=template&id=68f981a7"
import script from "./Paso3InstruccionesComponent.vue?vue&type=script&lang=js"
export * from "./Paso3InstruccionesComponent.vue?vue&type=script&lang=js"

import "./Paso3InstruccionesComponent.vue?vue&type=style&index=0&id=68f981a7&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__